module.exports = __webpack_public_path__ + "media/images/nav_social/nav_twitter-5e8c95c0da964f67281881e4f279b82b.svg";